// src/components/admin/ManageProducts.js

import React, { useState, useEffect } from "react";
import axios from "axios";

const ManageProducts = () => {
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    name: "",
    type: "",
    description: "",
    price: "",
    image: "",
  });
  const [editProduct, setEditProduct] = useState(null);

  useEffect(() => {
    //Fetch products from server
    const fetchProducts = async () => {
      const response = await axios.get("/api/products");
      setProducts(response.data);
    };

    fetchProducts();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProducts((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddProduct = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/products", newProduct);
      setProducts((prev) => [...prev, response.data]);
      setNewProduct({
        name: "",
        type: "",
        description: "",
        price: "",
        image: "",
      });
    } catch (error) {
      console.error("Error adding product", error);
    }
  };

  const handleEditProduct = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        "/api/products/${editProduct._id",
        editProduct
      );
      setProducts((prev) =>
        prev.map((product) =>
          product._id === editProduct._id ? response.data : product
        )
      );
      setEditProduct(null);
    } catch (error) {
      console.error("Error editing product", error);
    }
  };

  const handleDeleteProduct = async (id) => {
    try {
      await axios.delete(`/api/products/${id}`);
      setProducts((prev) => prev.filter((product) => product._id !== id));
    } catch (error) {
      console.error("Error deleting product", error);
    }
  };

  //Implement add, edit, delete product functionality here

  return (
    <div>
      <h2>Manage Products</h2>
      {/*Add Products Form */}
      <h3>Add Product</h3>
      <form onSubmit={handleAddProduct}>
        <input
          type="text"
          name="name"
          value={newProduct.name}
          onChange={(e) => handleInputChange(e, setNewProduct)}
          placeholder="Product Name"
          required
        />
        <input
          type="text"
          name="type"
          value={newProduct.type}
          onChange={(e) => handleInputChange(e, setNewProduct)}
          placeholder="Product Type"
          required
        />
        <input
          type="text"
          name="description"
          value={(e) => handleInputChange(e, setNewProduct)}
          placeholder="Product Description"
          required
        />
        <input
          type="number"
          name="price"
          value={newProduct.price}
          onChange={(e) => handleInputChange(e, setNewProduct)}
          placeholder="Product Price"
          required
        />
        <input
          type="text"
          name="image"
          value={newProduct.image}
          onChange={(e) => handleInputChange(e, setNewProduct)}
          placeholder="Product Image URL"
          required
        />
        <button type="submit">Add Product</button>
      </form>

      {/*Edit Product Form */}
      {editProduct && (
        <div>
          <h3>Edit Product</h3>
          <form onSubmit={handleEditProduct}>
            <input
              type="text"
              name="name"
              value={editProduct.name}
              onChange={(e) => handleInputChange(e, setEditProduct)}
              placeholder="Product Name"
              required
            />
            <input
              type="text"
              name="type"
              value={editProduct.type}
              onChange={(e) => handleInputChange(e, setEditProduct)}
              placeholder="Product Type"
              required
            />
            <input
              type="text"
              name="description"
              value={editProduct.description}
              onChange={(e) => handleInputChange(e, setEditProduct)}
              placeholder="Product Description"
              required
            />
            <input
              type="number"
              name="price"
              value={editProduct.price}
              onChange={(e) => handleInputChange(e, setEditProduct)}
              placeholder="Product Price"
              required
            />
            <input
              type="text"
              name="image"
              value={editProduct.image}
              onChange={(e) => handleInputChange(e, setEditProduct)}
              placeholder="Product Image URL"
              required
            />
            <button type="submit">Save Changes</button>
            <button onClick={() => setEditProduct(null)}>Cancel</button>
          </form>
        </div>
      )}

      {/*Products List */}
      <h3>Product List</h3>
      <ul>
        {products.map((product) => (
          <li key={product._id}>
            <span>
              {product.name}-${product.price}
            </span>
            <button onClick={() => setEditProduct(product)}>Edit</button>
            <button onClick={() => handleDeleteProduct(product._id)}>
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ManageProducts;
